<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
    created() {
        window.location = '/login?code=' + window.location.href.split('ref/')[1]
    },
})
</script>
